import classnames from 'classnames';

import './error-message.scss';

type ErrorMessagePropsType = {
  className?: string;
  error: string;
};

const ErrorMessage = ({ className, error }: ErrorMessagePropsType) => (
  <div className={classnames('error-message', className)}>{error}</div>
);

export default ErrorMessage;
